import { Component, OnInit } from '@angular/core';
import { ReportsService } from '../services/reports.service';

@Component({
  selector: 'app-venue-health',
  templateUrl: './venue-health.component.html',
  styleUrls: ['./venue-health.component.css']
})
export class VenueHealthComponent implements OnInit {

  monthsThreshold: number = 1;
  fetching: boolean = false;
  venueHealthReports: VenueHealthReport[] = [];

  constructor(private reportService: ReportsService) { }

  ngOnInit(): void {
    this.getVenueHealthReport();
  }

  getVenueHealthReport(){
    this.fetching = true;
    this.reportService.getVenueHealthReport(this.monthsThreshold).subscribe({
      next: (res: VenueHealthReport[]) => {
        console.log(res);
        this.venueHealthReports = res;
        this.fetching = false;
      },
      error: (err) => {
        console.error(err);
        this.fetching = false;
      }
    });
  }

  exportToCSV() {
    if (!this.venueHealthReports || this.venueHealthReports.length === 0) return;

    const headers = ['Venue', 'Client', 'Issue Type', 'Details'];
    const csvData: string[][] = [];

    csvData.push(headers);

    this.venueHealthReports.forEach(report => {
      report.issues.forEach(issue => {
        const row: string[] = [];

        row.push(report.venue_name || '');
        row.push(report.client_name || '');

        // issues
        const issueTypeFormatted = issue.type === 'attendance_drop'
          ? 'Attendance Drop'
          : issue.type === 'game_cancellations'
          ? 'Game Cancellations'
          : 'Post Arrival Cancellations';
        row.push(issueTypeFormatted);

        // issue details
        let detailsText = '';
        if (issue.type === 'attendance_drop') {
          detailsText = `Recent Avg: ${issue.details.recent_avg}%, Compare Avg: ${issue.details.compare_avg}%, Target Drop: ${issue.details.target_value}%`;
        } else if (issue.type === 'game_cancellations' || issue.type === 'post_arrival_cancellations') {
          const dates = issue.details.dates?.map(date => new Date(date).toLocaleDateString()).join(', ') || '';
          detailsText = `Dates: ${dates}`;
        }
        row.push(detailsText);

        csvData.push(row);
      });
    });


    const csvContent = csvData.map(row =>
      row.map(cell => `"${cell.replace(/"/g, '""')}"`).join(',')
    ).join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `venue-health-report-${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

}
